import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { equipmentAlertCategorySearchSchema } from '@/routes/_staff/equipment/-shared/alerts/equipmentAlertCategorySearchSchema';
import { equipmentAlertFilterFields } from '@/routes/_staff/equipment/_layout/alerts/-shared/equipmentAlertFilterFields';
export const ItemAlertsSearchSchema = z.object({
  ...dataGridSearchFields,
  category: equipmentAlertCategorySearchSchema,
  freeText: z.string().optional(),
  placementPlaceIdIn: equipmentAlertFilterFields.placementPlaceIdIn
}).transform(search => {
  if (search.category !== 'REPLACEMENT_DUE' && search.placementPlaceIdIn != null) {
    return {
      ...search,
      placementPlaceIdIn: undefined
    };
  }
  return search;
});
export type ItemAlertsSearch = z.infer<typeof ItemAlertsSearchSchema>;